<div class="tier-list-info">
  <div class="row info reset-font">
    <p>
      You can drag & drop items to their desired tier. Currency dropped in a stack of {{ filter.cosmeticSettings.stackedGeneralCurrencyOneTierThreshold || 3 }} is moved one tier higher, a stack of {{ filter.cosmeticSettings.stackedGeneralCurrencyTwoTiersThreshold || 10 }} two tiers higher (configurable on the <a href="/quick-filters">Quick Filters</a> tab).
      @if (poe1) {
        <br />Currency values update every 4 hours from the in-game Currency Exchange. Unique values are pulled in every hour from <a href="https://poe.ninja/" target="_blank">poe.ninja</a>.
      } @else {
        <br />Currency values update every 4 hours from the in-game Currency Exchange. Uniques values are scraped once per day from <a href="https://www.pathofexile.com/trade2/search/poe2" target="_blank">the trade website</a>.
        <!-- Class-specific Uniques come from <a href="https://poe2.ninja/builds" target="_blank">poe2.ninja</a>. -->
      }

      @if (inflationData && filter.economy !== Economy.Fixed) {
        <br />Last Currency import date: <span class="normal-item-color">{{ inflationData.latestDate }}</span> <span class="extra-info"> (previous: {{ inflationData.previousDate }})</span>
        <br />Divine price change since previous import: <span class="normal-item-color" app-value baseType="Divine Orb" [showPreviousValue]="true"></span>
        (<span [style.color]="inflationData.color">{{ inflationData.formatted }}</span>)
        <!-- <br />Last Uniques import date: <span class="normal-item-color">{{ inflationData.latestUniquesDate }}</span> <span class="extra-info"> (previous: {{ inflationData.previousUniquesDate }})</span> -->
      }
    </p>
  </div>

  <div class="tier-options reset-buttons">
    <button type="button" class="btn reset-tier-btn" (click)="resetCurrentTabCustomTiers($event)">Reset Changed {{ tabNameResetTierMap[tierListTab] }} Tiers</button>
    <div class="reset-all-changed-row">
      <button type="button" class="btn reset-all-changed-tiers-btn" (click)="resetAllCustomTiers($event)">Reset All Changed Tiers</button>
      <button type="button" class="btn toggle-button toggle-changed-only-btn"
        title="Show only changed tiers"
        [class.active]="showChangedTierItemsOnly"
        (click)="showChangedTierItemsOnly = !showChangedTierItemsOnly">
        <span class="icon icon-filter"></span>
      </button>
    </div>
    <div>
      Economy:
      <app-select class="economy-select inline" [disabled]="false" [(ngModel)]="filter.economy" (selectedValueChange)="updateEconomy()">
        <app-option [value]="Economy.Fixed" text="Fixed (SSF)" />
        <app-option [value]="Economy.League" text="League" />
        <app-option [value]="Economy.LeagueHardcore" text="HC League" />
        <app-option [value]="Economy.Standard" text="Standard" />
        <app-option [value]="Economy.StandardHardcore" text="HC Standard" />
      </app-select>
    </div>
  </div>
</div>

<!-- <app-item-label [baseType]="'Mirror of Kalandra'" [image]="'/img/currency/currencyduplicate.webp'"></app-item-label> -->
<!-- <app-item-label [baseType]="'Winter\'s Bite'" [unique]="true" [image]="'/img/uniques/Nevermelt.png'"></app-item-label> -->
<!-- <app-item-label [gearData]="testGearData" [baseType]="'Dualstring Bow'" [image]="'/img/gear/weapons/twohandweapons/crossbows/2hcrossbow01.webp'"></app-item-label> -->

<div class="navigation">
  <ul role="tablist" class="nav nav-tabs main full-width" style="font-size: 1em;">
    <li role="presentation" class="menu-tab" [class.active]="tierListTab === 'currency'">
      <a (click)="selectTab('currency')">
        <span>Currency</span>
      </a>
    </li>
    @if (poe1 && !filter.ruthless) {
      <li role="presentation" class="menu-tab" [class.active]="tierListTab === 'divination-cards'">
        <a (click)="selectTab('divination-cards')">
          <span>@if (isMobile()) { Div Cards } @else { Divination Cards }</span>
        </a>
      </li>
    }
    <li role="presentation" class="menu-tab" [class.active]="tierListTab === 'uniques'">
      <a (click)="selectTab('uniques')">
        <span>Uniques</span>
      </a>
    </li>
    <li role="presentation" class="menu-tab" [class.active]="tierListTab === 'chance-bases'">
      <a (click)="selectTab('chance-bases')">
        <span>Chance Bases</span>
      </a>
    </li>
    <li role="presentation" class="menu-tab" [class.active]="tierListTab === 'gear'">
      <a (click)="selectTab('gear')">
        <span>Gear Bases</span>
      </a>
    </li>
    <li role="presentation" class="menu-tab" [class.active]="tierListTab === 'jewellery'">
      <a (click)="selectTab('jewellery')">
        <span>Jewellery Bases</span>
      </a>
    </li>
    <li role="presentation" class="menu-tab" [class.active]="tierListTab === 'items'">
      <a (click)="selectTab('items')">
        <span>Items</span>
      </a>
    </li>
    <li role="presentation" class="menu-tab" [class.active]="tierListTab === 'mods'">
      <a (click)="selectTab('mods')">
        <span>Mods</span>
      </a>
    </li>
  </ul>
</div>

<div style="clear: both">
  @if (tierListTab === 'currency') {
    <app-currency-tiers [filter]="filter" [divinationCardTab]="false" [changedOnly]="showChangedTierItemsOnly"></app-currency-tiers>
  } @else if (tierListTab === 'divination-cards') {
    <app-currency-tiers [filter]="filter" [divinationCardTab]="true" [changedOnly]="showChangedTierItemsOnly"></app-currency-tiers>
  } @else if (tierListTab === 'uniques') {
    <app-unique-tiers [filter]="filter" [changedOnly]="showChangedTierItemsOnly"></app-unique-tiers>
  } @else if (tierListTab === 'chance-bases') {
    <app-chance-base-tiers [filter]="filter" [changedOnly]="showChangedTierItemsOnly"></app-chance-base-tiers>
  } @else if (tierListTab === 'gear') {
    <app-gear-tiers [filter]="filter" [changedOnly]="showChangedTierItemsOnly"></app-gear-tiers>
  } @else if (tierListTab === 'jewellery') {
    <app-jewellery-tiers [filter]="filter" [changedOnly]="showChangedTierItemsOnly"></app-jewellery-tiers>
  } @else if (tierListTab === 'items') {
    <app-equipment-tiers [filter]="filter" [changedOnly]="showChangedTierItemsOnly"></app-equipment-tiers>
  } @else if (tierListTab === 'mods') {
    <app-mod-tiers [filter]="filter" [changedOnly]="showChangedTierItemsOnly"></app-mod-tiers>
  }
</div>
